module.exports = __webpack_public_path__ + "static/img/icon6.e0cdefd.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon6.png
// module id = srkp
// module chunks = 21